// Events
export const CLICK_PRIVACY_POLICY_LINK: string = 'CLICK_PRIVACY_POLICY_LINK';
export const UNDO_DISMISSAL_STARTED: string = 'UNDO_DISMISSAL_STARTED';
export const UNDO_DISMISSAL_SUCCEEDED: string = 'UNDO_DISMISSAL_SUCCEEDED';
export const UNDO_DISMISSAL_FAILED: string = 'UNDO_DISMISSAL_FAILED';

// Global Constants
export const CACHE_NAME: string = 'atlassian-growth-recos';
